export const GALLERIES_PATH = (id: any) => `/libraries/${id}`
export const GALLERY_DELETE_IMAGE_PATH = '/s3'

// it can be changed to less than 100 but need to rewrite logic to request thumbnails for wistia videos
export const GALLERY_SLICED_OFFSET = 100
